export function getReferralCodeFromCookie() {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [key, value] = cookie.trim().split('=');
    if (key === 'referral_code') {
      return decodeURIComponent(value);
    }
  }
  return null;
}
